/* v8 ignore file -- @preserve */
import { fireLinkTag } from './tagManager';

export const tagPromoBanner = (direction) => {
  const currentSlideIndex = document.querySelector('.slideshow-item.active [data-index]')?.dataset?.index;
  fireLinkTag({ event_name: `promo banner ${direction} ${+currentSlideIndex + 1 || 1}` });
};
